import { useEffect } from "react";

const publish = <E>(name: string, data: E) => window.dispatchEvent(new CustomEvent(name, { detail: data }));

export const usePublisher = () => publish;

export const useSubscriber = <E>(name: string, callback: (data: E) => void) => {
    useEffect(() => {
        const handleEvent = (e: any) => {
            callback(e);
        }

        window.addEventListener(name, handleEvent);
        return () => window.removeEventListener(name, handleEvent);
    }, [name, callback]);
}